// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};
/*
  InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function() {
    // If the multi-currency feature is enabled, update the product price
    this.prepareSuggestionProductPriceData();
   
    // Check on sale
    let memberSalePriceData = this.data.metafields?.find(mf =>
      mf.namespace === "custom" && mf.key === "member_price"
    );
    var memberSalePrice = memberSalePriceData?.value;
    var onSale = this.data.compare_at_price_min > this.data.price_min;
    // Format price
    //console.log("this.data",this.data);
    
    var price = Utils.formatMoney(this.data.price_min);
    var compareAtPrice = '';
    if (this.data && this.data.compare_at_price_min && onSale) {
        compareAtPrice = Utils.formatMoney(this.data.compare_at_price_min);
        if (Settings.getSettingValue('search.removePriceDecimal')) {
            price = Utils.removeDecimal(price);
            compareAtPrice = Utils.removeDecimal(compareAtPrice);
        }
    }
    // Build Price
    var result = '';
    if (Settings.getSettingValue('search.showSuggestionProductPrice')) {
        if (onSale && Settings.getSettingValue('search.showSuggestionProductSalePrice')) {
            result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE_SALE);
        } else {
            result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE);
        }
    }

    if(memberSalePrice && tng_logged_in==true){
      console.log("Member Price: ",memberSalePrice);
      return result
        .replace(/{{regularPrice}}/g, memberSalePrice)
        .replace(/{{compareAtPrice}}/g, compareAtPrice); 
    }else{
        return result
        .replace(/{{regularPrice}}/g, price)
        .replace(/{{compareAtPrice}}/g, compareAtPrice);
    } 
 
}
  */

if (tng_logged_in != true) {
  
  InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function() {
    // If the multi-currency feature is enabled, update the product price
    this.prepareSuggestionProductPriceData();
   
    // Check on sale
    let memberSalePriceData = this.data.metafields?.find(mf =>
      mf.namespace === "custom" && mf.key === "member_price"
    );
    var memberSalePrice = memberSalePriceData?.value;
    var onSale = this.data.compare_at_price_min > this.data.price_min;
    // Format price
    
    var price = Utils.formatMoney(this.data.price_min);
    var compareAtPrice = '';
    if (this.data && this.data.compare_at_price_min && onSale) {
        compareAtPrice = Utils.formatMoney(this.data.compare_at_price_min);
        if (Settings.getSettingValue('search.removePriceDecimal')) {
            price = Utils.removeDecimal(price);
            compareAtPrice = Utils.removeDecimal(compareAtPrice);
        }
    }
    //Build Price
    var result = '';
    if (Settings.getSettingValue('search.showSuggestionProductPrice')) {
        if (onSale && Settings.getSettingValue('search.showSuggestionProductSalePrice')) {
            result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE_SALE);
        } else {
            result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE);
        }
    }
    return result.replace(/{{regularPrice}}/g, price).replace(/{{compareAtPrice}}/g, compareAtPrice);
}

}else{

  InstantSearchResultItemProduct.prototype.compileTemplate = function() {
      if (this.isShow) {
          var searchTerm = Utils.stripHtml(Globals.currentTerm);
          // Product image
          var imageHTML = '';
          if (Settings.getSettingValue('search.showSuggestionProductImage') && this.imageUrl.length) {
              imageHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.IMAGE);
              imageHTML = imageHTML.replace(/{{imageUrl}}/g, this.imageUrl);
          }
          // Product title
          var productTitle = this.customizeProductTitle();
          productTitle = this._highlightSuggestionResult(productTitle, searchTerm);
          // SKU
          var skuHTML = '';
          if (Settings.getSettingValue('search.showSuggestionProductSku') && this.sku.length) {
              skuHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.SKU);
              skuHTML = skuHTML.replace(/{{sku}}/g, this.sku);
          }
          // Vendor
          var vendorHTML = '';
          if (Settings.getSettingValue('search.showSuggestionProductVendor') && this.vendor.length) {
              vendorHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.VENDOR);
              vendorHTML = vendorHTML.replace(/{{vendor}}/g, this.vendor);
          }

          var priceHTML = this.compileSuggestionProductPrice();

          var tempDiv = document.createElement('div');
          tempDiv.innerHTML = priceHTML;
          
          var sTag = tempDiv.querySelector('s');
          
          if (sTag) {
            var saleSpan = tempDiv.querySelector('[class*="product-sale-price"]');
          
            if (saleSpan) {
              var regularPrice = sTag.textContent.trim().replace(/\s+/g, '');
          
              // Get only the first text node (not nested span)
              var salePrice = saleSpan.childNodes[0].nodeValue.trim().replace(/\s+/g, '');
          
              // Clean any stray <br>
              salePrice = salePrice.replace(/<br\s*\/?>/gi, '').replace(/\n/g, '');
          
              if (regularPrice === salePrice) {
                sTag.remove();
              }
            }
          }
          
          priceHTML = tempDiv.innerHTML;
          //console.log(priceHTML);
        
           //if (tng_logged_in == true) {
               let memberPriceField = this.data.metafields?.find(mf =>
                   mf.namespace === "custom" && mf.key === "member_price"
               );
               if (memberPriceField && memberPriceField.value) {
                   memberPrice = memberPriceField.value;
                   if (memberPrice.includes('-')) {
                       let [previousValue, nextValue] = memberPrice.split('-').map(value => value.trim());
                       priceHTML = priceHTML.replace(/<span[^>]*>Member Price:[^<]*<\/span>/i, '');
                       priceHTML += '<span class="member-pricing">Member Price: ' + previousValue + ' - ' + nextValue + '</span>';
                   } else {
                    priceHTML = priceHTML.replace(/<span[^>]*>Member Price:[^<]*<\/span>/i, '');
                    priceHTML += "<span class='member-pricing'>Member Price: " + memberPrice + "</span>";                   
                   }
               }
           //}
          // Open the result item in new tab when selected
          var newTabAttr = Settings.getSettingValue('search.openProductNewTab') ? 'target="_blank"' : '';
          return this.getTemplate()
              .replace(/{{id}}/g, this.id)
              .replace(/{{escapedBlockType}}/g, Utils.stripHtml(this.parent.type))
              .replace(/{{url}}/g, this.url)
              .replace(/{{newTabAttribute}}/g, newTabAttr)
              .replace(/{{itemProductImage}}/g, imageHTML)
              .replace(/{{title}}/g, productTitle)
              .replace(/{{escapedTitle}}/g, Utils.stripHtml(productTitle))
              .replace(/{{itemProductSku}}/g, skuHTML)
              .replace(/{{itemProductVendor}}/g, vendorHTML)
              .replace(/{{itemProductPrice}}/, priceHTML)
              .replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion)
              .replace(/{{class.searchSuggestionItem}}/g, Class.searchSuggestionItem)
              .replace(/{{class.searchUiAutocompleteItem}}/g, Class.searchUiAutocompleteItem);
      } else {
          return '';
      }
  }

  
}

   
})();